 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML03_COPYRIGH from '@/components/xhtml/03_Copyrigh'
 import XHTML01_TITLE_PA from '@/components/xhtml/01_Title_Pa'
 import XHTML04_DEDICATI from '@/components/xhtml/04_Dedicati'
 import XHTML05_CONTENTS from '@/components/xhtml/05_Contents'
 import XHTML06_LIST_OF from '@/components/xhtml/06_List_of'
 import XHTML07_ACKNOWLE from '@/components/xhtml/07_Acknowle'
 import XHTML08_INTRODUC from '@/components/xhtml/08_Introduc'
 import XHTML09_1__THE_L from '@/components/xhtml/09_1__The_L'
 import XHTML10_2__FOUND from '@/components/xhtml/10_2__Found'
 import XHTML11_3__COORD from '@/components/xhtml/11_3__Coord'
 import XHTML12_4__ESTAB from '@/components/xhtml/12_4__Estab'
 import XHTML13_5__EFFEC from '@/components/xhtml/13_5__Effec'
 import XHTML14_6__MONOP from '@/components/xhtml/14_6__Monop'
 import XHTML15_7__THE_R from '@/components/xhtml/15_7__The_R'
 import XHTML16_APPENDIX from '@/components/xhtml/16_Appendix'
 import XHTML17_NOTES from '@/components/xhtml/17_Notes'
 import XHTML18_REFERENC from '@/components/xhtml/18_Referenc'
 import XHTML19_INDEX from '@/components/xhtml/19_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/05_Contents",
 			"name" : "xhtml/05_Contents",
 			"component" : XHTML05_CONTENTS
 		},
 		{
 			"path" : "/xhtml/06_List_of",
 			"name" : "xhtml/06_List_of",
 			"component" : XHTML06_LIST_OF
 		},
 		{
 			"path" : "/xhtml/07_Acknowle",
 			"name" : "xhtml/07_Acknowle",
 			"component" : XHTML07_ACKNOWLE
 		},
 		{
 			"path" : "/xhtml/08_Introduc",
 			"name" : "xhtml/08_Introduc",
 			"component" : XHTML08_INTRODUC
 		},
 		{
 			"path" : "/xhtml/09_1__The_L",
 			"name" : "xhtml/09_1__The_L",
 			"component" : XHTML09_1__THE_L
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js